const targetGroupType = {
    Teacher: 1,
    Student: 2,
    Everyone: 3,
}

export const targetGroupTextType = {
    Teacher: "Teacher",
    Student: "Student",
    Everyone: "Everyone",
}

export default targetGroupType;